import firebaseConfig from './firebase_config'
var defaultExport={}

//FireBase - //Since version 6.0.0 , config is fetched from firebase_config.js - for easier setup
defaultExport.firebaseConfig = firebaseConfig.config;

//App setup
defaultExport.adminConfig={
  "appName": "Sahajyoga App",
  "slogan":"Made with blessings of punitachariji maharaj",
  "design":{
    "sidebarBg":"sidebar-3.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"orange", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"white", // "white | black"
  },
  "showItemIDs":false,
  "allowedUsers":null, //If null, allow all users, else it should be array of allowd users
  "allowGoogleAuth":true, //Allowed users must contain list of allowed users in order to use google auth
  "allowRegistration":false, //Should there be register page
  "fieldBoxName": "Fields",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":[""],
  "showSearchInTables":true,
  "methodOfInsertingNewObjects":"push", //timestamp (key+time) | push - use firebase keys
  "goDirectlyInTheInsertedNode":true,
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",
  "googleMapsAPIKey":"AIzaSyC2r5IdKWt_IJ6XZI8X4y8I_igyFaTWf9o",
  "fieldsTypes":{
    "photo":["photo","image"],
    "dateTime":["end","start","eventDateStart","eventDateEnd"],
    "map":["map","latlng","location","eventLocation"],
    "textarea":["description"],
    "html":["content"],
    "radio":["radio","radiotf","featured"],
    "checkbox":["checkbox"],
    "dropdowns":["status","dropdowns"],
    "file":["video"],
    "rgbaColor":['rgba'],
    "hexColor":['color'],
    "relation":['collection_news','type','creator','group'],
    "iconmd":['icon'],
    "iconfa":['iconfa'],
    "iconti":['iconti'],
    "iconio":['iconio'],
  },
  "optionsForDateTime":[
    {"key":"end", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"start", "dateFormat":"X" ,"timeFormat":"HH:mm", "saveAs":"x"},
  ],
  "optionsForSelect":[
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"status","options":["just_created","confirmed","canceled"]},
      {"key":"radio","options":["no","maybe","yes"]},
      {"key":"radiotf","options":["true","false"]},
      {"key":"featured","options":["true","false"]}
  ],
  "optionsForRelation":[
      {
        //Firestore - Native
        "display": "name",
        "isValuePath": true,
        "key": "creator",
        "path": "/users",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "name"
      },
      {
        //Firestore - Native
        "display": "group",
        "isValuePath": true,
        "key": "group",
        "path": "/groups",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "group_eventid",
        "value": "name"
      },
      {
        //Firebase - Mimic function
        "display":"name",
        "key":"eventtype",
        "path":"",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":true,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      }
  ],
  "paging":{
    "pageSize": 20,
    "finite": true,
    "retainLastPage": false
  },
  "hiddenKeys":["keyToHide","anotherKeyToHide"],
  "previewOnlyKeys":["previewOnlyKey","anotherPreviewOnlyKye"],
}

//Navigation
defaultExport.navigation=[
    {
      "link": "/",
      "name": "Dashboard",
      "schema":null,
      "icon":"home",
      "path": "",
       isIndex:true,
    },
    {
      "link": "fireadmin",
      "path": "images/items",
      "name": "Images",
      "icon":"image",
      "tableFields":["image"]
    },
    {
      "link": "fireadmin",
      "path": "meets",
      "name": "Meets",
      "icon":"event",
      "tableFields":[],
      "subMenus":[
        {
          "link": "fireadmin",
          "path": "meets/poonam/items",
          "name": "Poonam",
          "icon":"event",
          "tableFields":["locationName","description","eventDateStart", "image"]
        }
      ]
    },
    /*{
      "link": "fireadmin",
      "path": "events",
      "name": "Events",
      "icon":"event",
      "tableFields":[],
      "subMenus":[
        {
          "link": "fireadmin",
          "path": "events/skopje/items",
          "name": "Skopje",
          "icon":"event",
          "tableFields":["name","description","club.name","start", "photo"],
        },{
          "link": "fireadmin",
          "path": "events/sofia/items",
          "name": "Sofia",
          "icon":"event",
          "tableFields":["name","description"],
        },{
          "link": "fireadmin",
          "path": "events/belgrade/items",
          "name": "Belgrade",
          "icon":"event",
          "tableFields":["name","description"],
        }
      ]
    },
    {
      "link": "fireadmin",
      "path": "clubs",
      "name": "Clubs",
      "icon":"room",
      "tableFields":["name","description"],
      "subMenus":[
        {
          "link": "fireadmin",
          "path": "clubs/skopje/items",
          "name": "Skopje",
          "icon":"event",
          "tableFields":["name","description"]
        },{
          "link": "fireadmin",
          "path": "clubs/sofia/items",
          "name": "Sofia",
          "icon":"event",
          "tableFields":["name","description"],
        },{
          "link": "fireadmin",
          "path": "clubs/belgrade/items",
          "name": "Belgrade",
          "icon":"event",
          "tableFields":["name","description"],
        }
      ]
    },*/
    {
      "link": "fireadmin",
      "path": "videos",
      "name": "Videos",
      "icon":"movie",
      "tableFields":["name","description"],
      "subMenus":[
        {
          "link": "fireadmin",
          "path": "videos/youtube/items",
          "name": "Youtube",
          "icon":"videocam",
          "tableFields":["image","name","url"]
        }
      ]
    },{
      "link": "push",
      "path": "",
      "name": "Push notification",
      "icon":"speaker_notes",
      "tableFields":[],
    },
    {
      "link": "fireadmin",
      "path": "users/{useruuid}",
      "name": "My Profile",
      "icon": "perm_identity",
      "tableFields":[],
    }
    /*{
      "link": "fireadmin",
      "path": "bookings",
      "name": "Bookings",
      "icon":"done",
      "tableFields":[],
    },{
      "link": "fireadmin",
      "path": "static",
      "name": "Cities & Genres",
      "icon":"location_city",
      "tableFields":[],
    },{
      "link": "firestoreadmin",
      "path": "events",
      "name": "FireStore Events",
      "icon":"event",
      "tableFields":["name"],
    },{
      "link": "link",
      "path": "http://mobidonia.com",
      "name": "Mobidonia.com",
      "icon": "web",
      "tableFields":["name"],
    }*/
  ];

  //From v 5.1.0 we suggest remoteSetup due to security
  //
defaultExport.pushSettings={
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"expo", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AIzaSyC2r5IdKWt_IJ6XZI8X4y8I_igyFaTWf9o", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"ZmRmZjA0YmEtZTQzZS00MzMzLWFkNTgtNDM2ZWIwYzkwY2E0",
  "oneSignal_APP_KEY":"ac99783c-3e63-4af3-9ed4-db917a869449",
  "included_segments":"Active Users", //Only for onesignal push
  "firebasePathToTokens":"/expoPushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":true, //Should we store the notification in firestore
}

defaultExport.userDetails={

}

defaultExport.remoteSetup=false;
defaultExport.remotePath="admins/mobidonia";
defaultExport.allowSubDomainControl=false;
defaultExport.subDomainControlHolder="admins/";
defaultExport.isAppCreator=false;
defaultExport.appEditPath=undefined;

export default defaultExport;


// WEBPACK FOOTER //
// ./src/config/app.js